export default __webpack_public_path__ + "static/media/dmart.63d54c56.jpg";